module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-info alert-dismissable"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "aria-hidden": "true",
      "data-dismiss": "alert",
      "type": "button"
    }
  }, [_vm._v("×")]), _vm._v("\n  " + _vm._s(_vm.message) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1cd1931a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DismissableAlert.vue
// module id = 438
// module chunks = 1